import { createMachine, actions } from "xstate";

const { sendParent } = actions;

const createEntryListItemMachine = ({ entry }) => {
    return createMachine({
        id: 'entry-list-item',
        initial: 'idle',
        context: {
            ...entry
        },
        states: {
            idle: {
                on: {
                    DELETE: {
                        target: 'busy',
                        actions: sendParent((ctx) => ({
                            type: 'ENTRY.DELETE',
                            id: ctx.id
                        }))
                    },
                    TOGGLE_ARCHIVE: {
                        target: 'busy',
                        actions: sendParent((ctx, event) => ({
                            ...event,
                            type: 'ENTRY.TOGGLE_ARCHIVED',
                            id: ctx.id
                        }))
                    },
                    REFRESH_TITLE: {
                        target: 'busy',
                        actions: sendParent((ctx, event) => ({
                            ...event,
                            type: 'ENTRY.REFRESH_TITLE',
                            id: ctx.id
                        }))
                    },
                    INTENT_RENAME: {
                        target: 'busy',
                        actions: sendParent((ctx, event) => ({
                            ...event,
                            type: 'ENTRY.INTENT_RENAME',
                            id: ctx.id
                        }))
                    },
                    SHOW_QR_OVERLAY: {
                        actions: sendParent((ctx, event) => ({
                            ...event,
                            type: 'ENTRY.SHOW_QR_OVERLAY',
                            id: ctx.id
                        }))
                    },
                    BUSY: {
                        target: 'busy'
                    }
                }
            },
            busy: {
                on: {
                    IDLE: {
                        target: 'idle'
                    }
                }
            }
        }
    })
};

export { createEntryListItemMachine };
